import { createApiCall } from 'lib/base';

const CREATE_NHSV_WEBHOOK_CONFIG = 'CREATE_NHSV_WEBHOOK_CONFIG';

const apiCall = createApiCall<{ eventID: string; payload: any }>(
  CREATE_NHSV_WEBHOOK_CONFIG,
  ({ eventID, payload }) => ({
    endpoint: `api/admin/nhsv/webhook/events/${eventID}/configs`,
    method: 'POST',
    body: payload,
  })
);

export default apiCall;
